import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './MaintenanceBanner.less'
import { ReactComponent as InfoIcon } from '@/assets/info-filled.svg'
import { ReactComponent as CloseIcon } from '@/assets/close-filled.svg'

interface MaintenanceBannerProps {
  endDate?: string
}

const MaintenanceBanner = ({
  endDate
}: MaintenanceBannerProps): JSX.Element | null => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(true)

  const handleDismiss = (): void => {
    setIsVisible(false)
  }

  if (!isVisible || endDate == null || endDate.length === 0) {
    return null
  }

  return (
    <div className="maintenance-banner">
      <div className="maintenance-banner__content">
        <div className="maintenance-banner__icon">
          <InfoIcon width="19" height="19" />
        </div>
        <div className="maintenance-banner__message">
          {t('maintenanceBanner.message', { maintenanceEndTime: endDate })}
        </div>
        <button
          onClick={handleDismiss}
          className="maintenance-banner__close"
          type="button"
        >
          <CloseIcon width="18" height="18" />
        </button>
      </div>
    </div>
  )
}

export default MaintenanceBanner
